'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Behance';

var EntypoBehance = function EntypoBehance(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M8.072,9.301c0,0,1.892-0.147,1.892-2.459c0-2.315-1.548-3.441-3.51-3.441H0v12.926h6.454c0,0,3.941,0.129,3.941-3.816C10.394,12.51,10.566,9.301,8.072,9.301z M2.844,5.697h3.61c0,0,0.878,0,0.878,1.344c0,1.346-0.516,1.541-1.102,1.541H2.844V5.697z M6.271,14.029H2.844v-3.455h3.61c0,0,1.308-0.018,1.308,1.775C7.762,13.861,6.785,14.018,6.271,14.029z M15.649,6.688c-4.771,0-4.767,4.967-4.767,4.967s-0.326,4.941,4.767,4.941c0,0,4.243,0.254,4.243-3.437h-2.182c0,0,0.072,1.391-1.988,1.391c0,0-2.184,0.152-2.184-2.25h6.423C19.962,12.299,20.67,6.688,15.649,6.688z M17.59,10.574h-4.074c0,0,0.266-1.992,2.182-1.992S17.59,10.574,17.59,10.574z M18.097,4.16H12.98v1.594h5.117V4.16z' })
    );
};

exports.default = EntypoBehance;
module.exports = exports['default'];